/* Guide des tailles COVALIE (19/10/2026) : la fenêtre qui s'ouvre depuis le bundle, et le même contenu dans
   l'accordéon de la fiche. Onglets « Mesures produits / Mesures corps », menu « Changer vers » (FR, ES, IT).
   La fenêtre se ferme par la croix, en touchant à côté, ou avec la touche Échap. */
(function () {
  if (window.czGuide) return;

  function preparer(racine) {
    var menu = racine.querySelector('[data-cz-guide-systeme]');
    if (menu) menu.addEventListener('change', function () {
      [].forEach.call(racine.querySelectorAll('[data-sys]'), function (e) { e.hidden = e.getAttribute('data-sys') !== menu.value; });
    });
    [].forEach.call(racine.querySelectorAll('[data-onglet]'), function (b) {
      b.addEventListener('click', function () {
        var o = b.getAttribute('data-onglet');
        [].forEach.call(racine.querySelectorAll('[data-onglet]'), function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        [].forEach.call(racine.querySelectorAll('[data-panneau]'), function (p) { p.hidden = p.getAttribute('data-panneau') !== o; });
      });
    });
  }
  [].forEach.call(document.querySelectorAll('.cz-guide__contenu'), preparer);

  var fenetre = document.querySelector('[data-cz-guide]');
  if (!fenetre) return;
  /* posée à la racine de la page : un parent animé (transform) l'empêcherait de couvrir l'écran */
  document.body.appendChild(fenetre);
  var avant = null, minuteur = null, ouvertA = 0;

  function ouvrir() {
    clearTimeout(minuteur);
    ouvertA = Date.now();
    avant = document.activeElement;
    fenetre.hidden = false;
    document.documentElement.classList.add('cz-guide-ouvert');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fenetre.classList.add('est-ouvert'); });
      var x = fenetre.querySelector('.cz-guide__x'); if (x) x.focus({ preventScroll: true });
    });
  }
  function fermer() {
    fenetre.classList.remove('est-ouvert');
    document.documentElement.classList.remove('cz-guide-ouvert');
    minuteur = setTimeout(function () { fenetre.hidden = true; }, 260);
    if (avant && avant.focus) avant.focus({ preventScroll: true });
  }

  /* 19/10/2026 : un client pressé retouche le lien pendant l'ouverture ; ce 2e toucher tombe sur le fond et refermait
     la fenêtre aussitôt. Pendant 900 ms après l'ouverture, seule la croix ferme. */
  fenetre.addEventListener('click', function (e) {
    var f = e.target.closest('[data-cz-guide-fermer]'); if (!f) return;
    if (Date.now() - ouvertA < 900 && !f.classList.contains('cz-guide__x')) return;
    fermer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !fenetre.hidden) fermer(); });
  /* le lien est dans une carte du bundle (un <label>) : on l'intercepte avant, pour ne pas changer d'offre */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cz-guide-ouvrir]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    ouvrir();
  }, true);

  window.czGuide = { ouvrir: ouvrir, fermer: fermer };
})();
